import React from 'react';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAttendance } from '../viewmodels/AttendanceProvider';
import AppTheme from '../../../components/theme/AppTheme';
export default function AttendancePrompt() {
  const vm = useAttendance(), navigate = useNavigate();
  return vm?.prompt ? <AppTheme><Alert type="info" message="What were you doing?" description="Please explain your time away in My attendance." closable onClose={vm.dismissPrompt} action={<Button onClick={() => { navigate('/settings/attendance/my-attendance', { state: { attendancePeriod: vm.prompt } }); vm.dismissPrompt(); }}>Explain now</Button>} /></AppTheme> : null;
}
